// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://3.123.117.58/alpha',
  // filesSrc: 'http://3.123.117.58',
  // apiUrl: 'http://localhost/Projects/CaptisInvestmentApp/CaptisAPI/bot-api/public/alpha',
  // filesSrc: 'http://localhost/Projects/CaptisInvestmentApp/CaptisAPI/bot-api/public',
  // apiUrl: 'http://localhost/Projects/Captis/captis-investment/bot-api/public/alpha',
  // filesSrc: 'http://localhost/Projects/Captis/captis-investment/bot-api/public',

  //Loval DEV
  // apiUrl: 'http://localhost/Projects/CaptisInvestmentApp/Alpha/bot-api/public/alpha',
  // filesSrc: 'http://localhost/Projects/CaptisInvestmentApp/Alpha/bot-api/public',

  //live
  apiUrl: 'https://hearkenapi.rtp1.co.za/Alpha/bot-api/public/alpha',
  filesSrc: 'https://hearkenapi.rtp1.co.za/Alpha/bot-api/public',

  shippingCostsByCartTotalTiers : [
    {
      'name' : 'tier1',
      'cap-min' : 0,
      'cap-max' : 2500,
      'fixed-fee': 200,
      'percantage-fee' : 3,
      'weight-tiers': [
        {
          'max-volumentric-weight-kg' : 3.5,
          'charge-per-km-local': 5 ,
          'charge-per-km-outbounds': 5,
          'charge-per-km-crossborder': 5,
        },

        {
          'max-volumentric-weight-kg' : 7.5,
          'charge-per-km-local': 8 ,
          'charge-per-km-outbounds': 15,
          'charge-per-km-crossborder': 25,
        },

        {
          'max-volumentric-weight-kg' : 15.5,
          'charge-per-km-local': 9 ,
          'charge-per-km-outbounds': 20,
          'charge-per-km-crossborder': 35,
        }
      ]
      
    },

    {
      'name' : 'tier2',
      'cap-min' : 2501,
      'cap-max' : 5500,
      'fixed-fee': 0,
      'percantage-fee' : 6,
      'weight-tiers': [
        {
          'max-volumentric-weight-kg' : 3.5,
          'charge-per-km-local': 5 ,
          'charge-per-km-outbounds': 5,
          'charge-per-km-crossborder': 5,
        },

        {
          'max-volumentric-weight-kg' : 7.5,
          'charge-per-km-local': 8 ,
          'charge-per-km-outbounds': 15,
          'charge-per-km-crossborder': 25,
        },

        {
          'max-volumentric-weight-kg' : 15.5,
          'charge-per-km-local': 9 ,
          'charge-per-km-outbounds': 20,
          'charge-per-km-crossborder': 35,
        },

        {
          'max-volumentric-weight-kg' : 1000000,
          'charge-per-km-local': 9 ,
          'charge-per-km-outbounds': 20,
          'charge-per-km-crossborder': 35,
        }
      ]
      
    },

    {
      'name' : 'tier3',
      'cap-min' : 5501,
      'cap-max' : 2500,
      'fixed-fee': 0,
      'percantage-fee' : 0,
      'weight-tiers': [
        {
          'max-volumentric-weight-kg' : 3.5,
          'charge-per-km-local': 2 ,
          'charge-per-km-outbounds': 2,
          'charge-per-km-crossborder': 3,
        },

        {
          'max-volumentric-weight-kg' : 4,
          'charge-per-km-local': 4 ,
          'charge-per-km-outbounds': 10,
          'charge-per-km-crossborder': 15,
        },

        {
          'max-volumentric-weight-kg' : 8.5,
          'charge-per-km-local': 6 ,
          'charge-per-km-outbounds': 10,
          'charge-per-km-crossborder': 25,
        }
      ]
      
    }
  ]
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
